import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package, delivery"><path d="M8.75 3.75H3.75V20.25H20.25V3.75H15.25M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M13.75 16.25H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackage;
